/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMPasswordRecoveryCompleteEvent } from '@/data/events/handlers/gtm/PasswordRecoveryComplete';
import { GTMPasswordRecoveryCompletePayload } from '@/data/types/GTM';

type PasswordRecoveryCompleteDelegatorProps = {
	gtm?: GTMPasswordRecoveryCompletePayload;
};

export const passwordRecoveryCompleteDelegator = async (
	payload: PasswordRecoveryCompleteDelegatorProps
) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMPasswordRecoveryCompleteEvent(gtm);
	}
};
